import { Label } from "@fluentui/react";
import React from "react";
import RequestByDropdown from "../elements/requestByDropdown/RequestByDropdown";
import { ITeamTypeSettingProps } from "../../../../../interfaces/teamTypeSettings/ITeamTypeSettingProps";
import ApprovalByDropdown from "../elements/approvalByDropdown/ApprovalByDropdown";

export default function UpgradeGroup(props: ITeamTypeSettingProps) {
	return <>
		<Label>Kan ingediend worden door</Label>

		<RequestByDropdown
			selectedKeys={props.values.settings.upgradeGroup.requestBy}
			onChange={(option) => props.updateRequestOrApprovalBySettings("upgradeGroup", "requestBy", option)}
		/>

		<ApprovalByDropdown
			selectedKeys={props.values.settings.upgradeGroup.approvalBy}
			onChange={(option) => props.updateRequestOrApprovalBySettings("upgradeGroup", "approvalBy", option)}
		/>
	</>;
}